module.exports = __webpack_public_path__ + "pn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/pn.svg
// module id = 1019
// module chunks = 0